import * as Yup from 'yup';
import getMaximumDecimalSchema from './getMaximumDecimalSchema';

const MAXIMUM_MESSAGE = 'must not be more than 100%.';
const MINIMUM_MESSAGE = 'must be greater than 0%.';
const REQUIRED = 'is required.';

/*
  A percent that may be left blank.  CasRHFTextField hands the resolver a null for an untouched
  numeric input, so the blank case is a real value to allow rather than an absent one - hence
  .nullable() plus the transform.  moreThan, max and the decimal test all pass an absent value
  through, so a blank row validates cleanly.
*/
export function getNullablePercentSchema(
  customMessage: string,
  max: number = 100,
  maxDecimalPlaces: number = 3
) {
  return Yup.number()
    .concat(getMaximumDecimalSchema(maxDecimalPlaces))
    .nullable()
    .transform((value, original) => (original === '' || original == null ? null : value))
    .typeError('Please enter a valid percentage')
    .moreThan(0, `${customMessage} ${MINIMUM_MESSAGE}`)
    .max(max, `${customMessage} ${MAXIMUM_MESSAGE}`);
}

/*
  The same percent, required.  Built from the nullable one so the bounds, the decimal limit and
  the message wording are stated once - the two are used side by side on the same forms, and a
  rate that validated differently depending on which builder it came from would be a puzzle.
*/
export default function getPercentSchema(
  customMessage: string,
  max: number = 100,
  maxDecimalPlaces: number = 3
) {
  return getNullablePercentSchema(customMessage, max, maxDecimalPlaces)
    .required(`${customMessage} ${REQUIRED}`
  );
}
